import React from 'react'
import ProductPage from '../../Components/products/ProductPage'
import CommonLayout from '../../Components/CommonLayout/CommonLayout'

function ProductDetails({meta}) {
    return(<>
     <div className="p-5">
     <CommonLayout />
     <ProductPage/>
     </div>
    </>)
}

export default ProductDetails